module.exports = __webpack_public_path__ + "img/qr-code-v2.2d4be3e1.svg";